import { render, staticRenderFns } from "./ProdList.vue?vue&type=template&id=52871a17&scoped=true&"
import script from "./ProdList.vue?vue&type=script&lang=js&"
export * from "./ProdList.vue?vue&type=script&lang=js&"
import style0 from "./ProdList.vue?vue&type=style&index=0&id=52871a17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52871a17",
  null
  
)

export default component.exports